export const noticeTableOption = {
    // 系统消息列表
    page: false,
    border: true,
    stripe: true,
    align: 'center',
    menu: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: false,
    searchBtn: false,
    column: [{
      label: '内容',
      width: 500,
      prop: 'msgContent',
      solt: true,
      align: 'center',
      span: 24,
    }, {
      label: '发送者',
      width: 180,
      prop: 'msgFromName',
      solt: true,
      align: 'center',
      span: 24,
    }, {
      label: '接收者',
      width: 180,
      prop: 'msgToName',
      solt: true,
      align: 'center',
      span: 24,
    }, {
      label: '会话ID',
      width: 160,
      prop: 'convId',
      align: 'center',
    }, {
      // type: 'datetime',
      // valueFormat: 'timestamp',
      // format: 'yyyy-MM-dd hh:mm:ss',
      label: '发送时间',
      prop: 'sentTime',
      align: 'center'
    }]
}